import { useRequest } from 'ahooks'

import { withdrawAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/withdrawAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementWithdrawBatchButtonProps } from './interface'

export const AnnouncementWithdrawBatchButton = ({
  uuid
}: AnnouncementWithdrawBatchButtonProps) => {
  const { message } = useFeedback()

  const { selectedRowKeys, setSelectedRows, reload } = useRemoteTableStore(
    state => pick(state, ['selectedRowKeys', 'setSelectedRows', 'reload'])
  )

  const { loading, runAsync } = useRequest(
    () =>
      withdrawAnnouncementApi({ announcementIds: selectedRowKeys as string[] }),
    {
      manual: true,
      onSuccess() {
        message.success('批量撤销成功')
        setSelectedRows([])
        reload()
      }
    }
  )

  return (
    <ConfirmButton
      ghost
      warning
      disabled={!selectedRowKeys?.length}
      forbiddenStrategy='disable'
      loading={loading}
      message='确定批量撤销吗？'
      placement='top'
      type='primary'
      uuid={uuid}
      onConfirm={runAsync}
    >
      批量撤销
    </ConfirmButton>
  )
}
